// extracted by mini-css-extract-plugin
export default {"phoneNumbersParagraph":"PhoneNumberPanel_phoneNumbersParagraph__ngW2R"};